import { render } from "./vhpPlayer.vue?vue&type=template&id=85e114b0"
import script from "./vhpPlayer.vue?vue&type=script&lang=js"
export * from "./vhpPlayer.vue?vue&type=script&lang=js"

import "./vhpPlayer.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__